import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

/**
 * ArticleFooter - Reusable footer for all article pages
 * 
 * Features:
 * - "Helpful? Share this guide" with Web Share API
 * - Navigation links: All Articles and Next Article
 * 
 * @param {string} title - Article title for sharing
 * @param {string} nextArticleTitle - Title of the next suggested article
 * @param {string} nextArticleUrl - URL of the next suggested article
 */
export const ArticleFooter = ({
    title = 'IPTV Guide',
    nextArticleTitle = 'Best IPTV Service 2026',
    nextArticleUrl = '/blog/best-iptv-usa-2026'
}) => {
    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: title,
                url: window.location.href
            }).catch(() => {
                // User cancelled or share failed silently
            });
        } else {
            // Fallback: Copy to clipboard
            navigator.clipboard?.writeText(window.location.href);
            alert('Link copied to clipboard!');
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="py-8 border-t border-white/10 mt-8"
        >
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex items-center gap-3 text-muted-foreground">
                    <span className="text-sm">Helpful?</span>
                    <button
                        onClick={handleShare}
                        className="text-primary hover:underline text-sm font-medium"
                    >
                        Share this guide
                    </button>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <Link to="/blog" className="hover:text-primary transition">
                        ← All Articles
                    </Link>
                    <span>•</span>
                    <Link to={nextArticleUrl} className="hover:text-primary transition">
                        Next: {nextArticleTitle} →
                    </Link>
                </div>
            </div>
        </motion.div>
    );
};

export default ArticleFooter;
